import axios from 'axios'
import { ensureCsrfToken } from '../../../../lib/csrf'

const BASE = '/api/digital-risk/program-execution/'
export async function fetchProgramExecution(programReference) {
  const { data } = await axios.get(`${BASE}programs/${encodeURIComponent(programReference)}/`, { withCredentials: true })
  return data
}
export async function updateProjectExecution(executionReference, payload) {
  const { data } = await axios.patch(`${BASE}${encodeURIComponent(executionReference)}/`, payload, { withCredentials: true, headers: { 'X-CSRFToken': await ensureCsrfToken() } })
  return data
}
